module.exports = __webpack_public_path__ + "static/media/fourth.e03d116b.gif";